import { actions } from '../constants'

const initialState = {
  oldGraphic: {},
  activeOldGraphicRestrID: undefined,
}

const reducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case actions.INITIALIZE:
      return {
        ...state,
        ...payload,
      }

    case actions.FETCH_SUCCESS:
      return {
        ...state,
        oldGraphic: {
          ...state.oldGraphic,
          [meta.RestrDate]: payload.oldGraphic,
        },
        activeOldGraphicRestrDate: meta.RestrDate,
      }

    case actions.SWITCH_OLD_GRAPHIC:
      return {
        ...state,
        activeOldGraphicRestrID: meta.ID,
        activeOldGraphicRestrDate: meta.RestrDate,
      }

    default:
      return state
  }
}

export default reducer
